import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type UpdateProductRequestDto = ClientInferRequest<typeof contract.products.update>["body"];

export type UpdateProductResponseDto = ClientInferResponseBody<
  typeof contract.products.update,
  200
>;

export const updateProduct = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateProductRequestDto;
}): Promise<UpdateProductResponseDto | null> => {
  const response = await api.products.update.mutation({
    params: { id },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
